<template>
  <!-- 图文列表 -->
  <div class="main">
    <div>
      <div class="public_text">
        <div class="public_t">
          <a @click="prime(name)">{{ name }}</a>
        </div>
      </div>
      <!-- 图文 -->
      <div v-if="articleList.length" style="min-height: 650px;">
        <div v-for="(item) in articleList" :key="item.title" class="text-image-list">
          <div v-if="notice.showType ==1 " class="item">
            <div v-if="item.thumbnailPath" class="item-img">
              <a>
                <img
                  :src="cfg.imageDomain +item.thumbnailPath"
                  @click="jumpNews(item.id,item.customUrl)"
                >
              </a>
            </div>

            <div class="item-texts" :style="item.thumbnailPath ? 'width: 860px;':'width:100%;'">
              <div class="item-title">
                <a
                  class="link"
                  style="width: 860px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                  @click="jumpNews(item.id,item.customUrl)"
                >
                  <span style="font-weight:bold;">{{ item.title }}</span>
                </a>
              </div>
              <div class="item-normal">
                <span class="source">{{ item.author }}</span>

                <span class="time">{{ time(item.publishTime) }}</span>
              </div>
              <div class="item-descri">
                <a @click="jumpNews(item.id,item.customUrl)">{{ item.newContent }}</a>
              </div>
              <div class="item-normal">
                <a class="goinfo" @click="jumpNews(item.id,item.customUrl)">详情</a>
                <div style="clear:both" />
              </div>
            </div>
            <div style="clear:both" />
          </div>

          <!-- 文字 -->
          <!-- <div v-if="notice.navigationType ==0 && item.thumbnailPath ==''" class="item">
          <div class="item-texts text">
            <div class="item-title">
              <a class="link">
                <span style="font-weight:bold;">【远医试点】民盟贵州省委赴七星关区开展医疗帮扶</span>
              </a>
            </div>
            <div class="item-normal">
              <span class="source">民盟省委社会服务处</span>

              <span class="time">2020-06-03</span>
            </div>
            <div class="item-descri">
              <a>&nbsp;&nbsp;&nbsp;6月2日，民盟贵州省委会同贵州医科大学附属医院专家到毕节市七星关区长春堡镇卫生院开展医疗帮扶。在长春堡镇卫生院远程门诊室，由贵州医科大学附属医院儿内科副主任医师张力亲自坐诊，对8例典型病例进行问诊、会诊。并通过远程系统对各村卫生室村医和小吉场镇、水箐镇卫生院的医生进行现场案例教学培训。在教学过程中，大家认真观看和记录，对小儿肾脏疾病...</a>
            </div>
            <div class="item-normal">
              <a class="goinfo">详情</a>
              <div style="clear:both" />
            </div>
          </div>
        </div> -->
          <!-- 文字列表 -->
          <div v-if="notice.showType == 0">
            <div class="ranking-list">
              <dl>
                <dd>
                  <a class="link" @click="jumpNews(item.id,item.customUrl)">
                    <span class="point">
                      <img
                        class="public_item_icon_img"
                        src="https://sf-image.wjzpgz.com/minmeng/attaches/dot.png"
                        alt
                      >
                    </span>
                    <span>{{ item.title }}</span>
                  </a>
                </dd>
                <dd class="time">
                  <span>{{ time(item.publishTime) }}</span>
                </dd>
              </dl>
              <div style="clear:both" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="text-align:center">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="list.total"
        :page-size="15"
        :current-page="current"
        :hide-on-single-page="value"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getArticleList } from '@/api/common';
import { deleteHtmlTag, handlerStr } from '@/utils';
export default {
  props: { 'notice': {
    type: Object,
    default: null
  }},
  data() {
    return {
      pageSize: '',
      value: true,
      current: 1,
      list: {},
      name: '',
      nextName: '',
      articleList: []
    };
  },
  watch: {
    '$route'(to, from) {
      this.refresh(this.$route.query.name)
    }

  },
  created: function() {
    this.handleCurrentChange(1);
  },
  methods: {
    refresh() {
      this.handleCurrentChange(1);
    },
    time(timestamp) {
      const date = new Date(timestamp);
      const y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + MM + '-' + d + ' ';
    },
    handleCurrentChange(val) {
      // this.list = ''
      this.name = this.notice.name;
      this.nextName = this.$route.query.name
      const data = this.buildParams({ pageNo: val, pageSize: 15, columnName: this.nextName });

      getArticleList(data).then(res => {
        const data = res.data
        for (let i = 0; i < res.data.rows.length; i++) {
          data.rows[i].newContent = data.rows[i].newContent && this.handlerStr(data.rows[i].content);
        }
        this.list = data;
        this.articleList = data.rows;
      })
    },
    jumpNews(id, customUrl) {
      if (customUrl) {
        var windowOpen = window.open()
        windowOpen.location = customUrl;
      } else {
        this.$router.push({ path: '/news', query: { id: id }});
      }
    },
    prime(name) {
      this.nextName = name
      const data = this.buildParams({ pageNo: 1, pageSize: 15, columnName: name });
      getArticleList(data).then(res => {
        const data = res.data;

        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].newContent = this.handlerStr(data.rows[i].content)
        }
        this.list = data;
        this.articleList = data.rows;
      })
    },
    handlerStr(str) {
      return str && handlerStr(deleteHtmlTag(str), 200)
    }

  }

};
</script>

<style scoped>
a {
  margin: 0;
  padding: 0;
  border: 0;
  color: #3c3c3c;
  font-size: 14px;
  font-family: 宋体;
}
.main {
  overflow: hidden;
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}

.public_text {
  margin-top: 14px;
  font: 400 14px/22px PingFangSC;
  color: #fff;
  background: #e4effa;
  padding-right: 14px;
  position: relative;
}
.public_t {
  padding: 9px 28px;
  color: #fff;
  background: #367dbe;
  display: inline-block;
  font: 400 16px/22px PingFangSC;
}
.public_t a {
  font: 400 14px/22px PingFangSC;
  color: #fff;
}
.item {
  clear: both;
  background: #fff;
  margin-bottom: 15px;
}
.item .item-img {
  float: left;
  width: 336px;
  height: 184px;
}
.item-img img {
  width: 336px;
  height: 184px;
}
.item-texts {
  width: 860px;
  min-width: 580px;
  float: right;
  padding: 20px;
}
.text {
  width: 100%;
  min-width: 580px;
  float: right;
  padding: 20px;
}
.link {
  width: 860px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  line-height: 30px;
  color: #333333;
  text-decoration: none;
  clear: both;
  float: left;
}
a.link:hover {
  color: #c30734;
}
.item .item-normal {
  clear: both;
  line-height: 30px;
}
.item .item-normal span {
  font-size: 12px;
  color: #9b9b9b;
}
.item-descri {
  clear: both;
  color: #9b9b9b;
  line-height: 20px;
}
.item-descri a:hover {
  color: #2386e2;
  text-decoration: underline;
}
.item-normal {
  clear: both;
  line-height: 30px;
}
.goinfo {
  margin-bottom: 10px 0 0 20px;
  font-size: 12px;
  padding: 0 20px 0 20px;
  float: right;
  text-decoration: none;
  border: 1px solid #ccc;
  color: #9b9b9b;
}
.goinfo:hover {
  border: 1px solid #c30734;
  background: #c30734;
  color: #fff;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}

.ranking-list dl {
  clear: both;
  background: #fff;
  margin-bottom: 0px;
  overflow: hidden;
  padding: 3px;
  margin-top: 0;
}
.ranking-list dl dd {
  float: left;
  line-height: 30px;
}
.ranking-list dl dd a.link {
  font-size: 14px;
  float: left;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  white-space: nowrap;
}
.ranking-list dl dd a.link:hover {
  color: #367dbe;
  text-decoration: underline;
}
.ranking-list dl dd .point {
  color: #c30734;
  font-size: 18px;
  margin-left: 10px;
}
.public_item_icon_img {
  width: 9px;
  height: 8px;
  margin: 5px;
  vertical-align: middle;
}
.ranking-list dl dd.time {
  float: right;
  font-size: 14px;
  color: #888;
}
</style>
